import { render, staticRenderFns } from "./basic-video.vue?vue&type=template&id=7ad46e72&scoped=true&"
import script from "./basic-video.vue?vue&type=script&lang=js&"
export * from "./basic-video.vue?vue&type=script&lang=js&"
import style0 from "./basic-video.vue?vue&type=style&index=0&id=7ad46e72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad46e72",
  null
  
)

export default component.exports